<template>
  <section class="bg-white">
    <div class="co-container-md mx-auto px-4 py-20">
      <h2 class="ya-te-page-title ya-te-text-primary mb-8 text-center font-extrabold sm:mb-12">
        数字でわかる<br class="md:hidden">LINEヤフーテックアカデミー
      </h2>
      <div class="flex flex-col gap-8 md:flex-row">
        <div class="w-full md:w-1/3">
          <img
            class="mx-auto mb-4"
            src="~/assets/images/YaTe/YaTeCounseling/Statistics/data-1.svg"
            alt="初心者率94%"
            width="308"
            height="151"
            loading="lazy"
          >
          <p class="co-display-13 mb-1">
            大半の方が未経験から受講。分かりやすいカリキュラムだから安心して始められます。
          </p>
          <p class="co-display-14 leading-normal text-co-gray-500">
            ※2022年11月から2024年7月末までに受講を完了し、アンケートに回答された方
          </p>
        </div>
        <div class="w-full md:w-1/3">
          <img
            class="mx-auto mb-4"
            src="~/assets/images/YaTe/YaTeCounseling/Statistics/data-2.svg"
            alt="修了率91%"
            width="308"
            height="151"
            loading="lazy"
          >
          <p class="co-display-13 mb-1">
            充実したサポートにより、9割以上の受講生が挫折せずにカリキュラムを修了しております。
          </p>
          <p class="co-display-14 leading-normal text-co-gray-500">
            ※学習を継続的に続けた方の修了率
          </p>
        </div>
        <div class="w-full md:w-1/3">
          <img
            class="mx-auto mb-4"
            src="~/assets/images/YaTe/YaTeCounseling/Statistics/data-3.svg"
            alt="満足度4.57/5%"
            width="308"
            height="151"
            loading="lazy"
          >
          <p class="co-display-13 mb-1">
            プロの手厚いサポートに対して満足の声、多数。だから挫折せずやりきれます。
          </p>
          <p class="co-display-14 leading-normal text-co-gray-500">
            ※2022年11月から2024年7月末までに受講を完了し、アンケートに回答された方
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import url("~/assets/css/YaTe/YaTeCommon/YaTeCommon.css");
</style>
